'use client';

import { ComponentProps, ReactNode } from 'react';
import { XMarkIcon } from '@heroicons/react/24/solid';
import clsx from 'clsx';

import styles from './AnnouncementBar.module.css';

interface AnnouncementBarProps extends Omit<ComponentProps<'div'>, 'children'> {
  className?: string;
  message: string;
  cta?: ReactNode;
  onClose?: () => void;
}

export default function AnnouncementBar({ className, message, cta, onClose, ...props }: AnnouncementBarProps) {
  return (
    <div
      className={clsx(styles.banner, className)}
      {...props}
    >
      <div className={styles.content}>
        <span className={styles.message}>{message}</span>
        {cta}
      </div>

      {onClose && (
        <button
          aria-label="Close banner"
          className={styles.closeButton}
          onClick={onClose}
          type="button"
        >
          <XMarkIcon
            aria-hidden="true"
            className={styles.closeIcon}
          />
        </button>
      )}
    </div>
  );
}
